<template>
  <div class="view-gabarit">
    <h2 class="head-box-title">{{ $t('exportStudy') }}</h2>

    <div class="export-container">
      <div class="export-box">
        <i class="icon-slides" />

        <div class="content">
          <h3>{{ $t('modal.shortExport') }}</h3>
          <div class="description">{{ $t('modal.shortExportBaseline') }}</div>
        </div>

        <button class="study-button main" @click="() => exportStudy(ExportType.Short)">{{ $t('choose') }}</button>
      </div>

      <div class="separator-v" />

      <div class="export-box">
        <i class="icon-rapport" />

        <div class="content">
          <h3>{{ $t('modal.simpleExport') }}</h3>
          <div class="description">{{ $t('modal.simpleExportBaseline') }}</div>
        </div>

        <button class="study-button main" @click="() => exportStudy(ExportType.Simplified)">{{ $t('choose') }}</button>
      </div>

      <div class="separator-v" />

      <div class="export-box">
        <i class="icon-rapportspecific" />

        <div class="content">
          <h3>{{ $t('modal.specificExport') }}</h3>
          <div class="description">{{ $t('modal.specificExportBaseline') }}</div>
        </div>

        <button class="study-button main" @click="() => exportStudy(ExportType.Specific)">{{ $t('choose') }}</button>
      </div>

      <div v-if="userInfo.role_id !== 3" class="separator-h" />

      <div v-if="userInfo.role_id !== 3" class="export-box horizontal">
        <i class="icon-csv" />

        <div class="content">
          <h3>{{ $t('modal.spreadsheetFormat') }}</h3>
          <div class="description">{{ $t('modal.spreadsheetFormatBaseline') }}</div>
        </div>

        <button class="study-button" @click="downloadExportExcel(params.id)">{{ $t('download') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ExportType from '@/pure/ExportType';

export default {
  props: ['params'],

  computed: {
    ...mapGetters(['study', 'userInfo']),

    ExportType() {
      return ExportType;
    },
  },

  methods: {
    ...mapActions(['createExport', 'patchExport']),

    exportStudy(exportType) {
      const { id } = this.params;

      this.createExport({ id, type: exportType }).then(({ public_id: studyId }) => {
        const exportData =
          this.study && this.study.personalized_transport_only
            ? {
                sites_id: null,
                walk_transport_enabled: false,
                bicycle_transport_enabled: false,
                optimized_transport_enabled: false,
                custom_transport_enabled: true,
                public_transport_type: 0,
                individual_transport_type: 0,
                sections: ['synthesis', 'transit', 'impact', 'outlier', 'environmental'],
                status: 6,
              }
            : {
                sites_id: null,
                walk_transport_enabled: this.study && this.study.withWalkingTimes && !this.study.individual_transport_only,
                bicycle_transport_enabled: this.study && !this.study.individual_transport_only,
                optimized_transport_enabled: false,
                custom_transport_enabled: false,
                public_transport_type: this.study && this.study.individual_transport_only ? 0 : 1,
                individual_transport_type: 1,
                sections: ['synthesis', 'transit', 'impact', 'outlier', 'environmental'],
                status: 6,
              };

        if (exportType === ExportType.Short) {
          this.patchExport({ id: studyId, payload: exportData }).then(() => {
            this.$router.push({
              name: 'exportTransportMode',
              params: { studyId },
            });
          });
        }

        if (exportType === ExportType.Simplified) {
          this.patchExport({ id: studyId, payload: exportData }).then(() => {
            this.$router.push({
              name: 'exportConfiguration',
              params: { studyId },
            });
          });
        }

        if (exportType === ExportType.Specific) {
          this.$router.push({
            name: 'exportFilters',
            params: { studyId },
          });
        }
      });
    },

    downloadExportExcel(exportId) {
      this.$store.dispatch('getExportExcel', { id: exportId }).then(e => {
        this.downloadFile(e);
      });
    },

    downloadFile(blob) {
      const BlobUrl = window.URL.createObjectURL(blob.blob);

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob.blob, name || blob.name);
      } else {
        const link = document.createElement('a');
        link.download = decodeURI(blob.name);
        link.href = BlobUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.view-gabarit {
  width: 800px;
  max-width: 100%;

  .export-container {
    display: grid;
    grid-template-columns: 1fr 1px 1fr 1px 1fr;
    gap: 32px;

    .separator-h,
    .separator-v {
      background-color: #e3e3e3;
      width: 100%;
      height: 100%;
    }
    .separator-h {
      height: 1px;
      grid-column: 1 / -1;
    }
    .separator-v {
      width: 1px;
    }

    .export-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1;
      gap: 16px;

      &.horizontal {
        grid-column: 1 / -1;
        flex-direction: row;

        .content {
          text-align: left;
        }

        button {
          margin-left: auto;
          margin-top: 0;
        }
      }

      i {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #dbd6c7;
        font-size: 64px;
        width: 64px;
        height: 64px;
        margin: 0;

        &::before {
          margin: 0;
        }
      }

      .content {
        display: flex;
        flex-direction: column;
        gap: 8px;
        text-align: center;

        h3 {
          font-size: 16px;
          font-weight: 600;
          color: #262631;
        }

        .description {
          font-size: 14px;
        }
      }

      button {
        margin-top: auto;
      }
    }
  }
}
</style>
